(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aryaman-header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* ===== Mobile menu accordion (+ / -) ===== */
  (function () {
    if (window.__mmAccordionInit) return;
    window.__mmAccordionInit = true;

    function setItem(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector(':scope > .mm-row > .mm-toggle');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAllInside(item) {
      item.querySelectorAll('.mm-item.is-open').forEach(function (child) {
        setItem(child, false);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mm-toggle');
      if (!btn) return;

      e.preventDefault();

      var item = btn.closest('.mm-item');
      if (!item) return;

      var willOpen = !item.classList.contains('is-open');

      /* Same level par sirf ek item khula rahe */
      if (willOpen && item.parentElement) {
        Array.prototype.forEach.call(item.parentElement.children, function (sibling) {
          if (sibling !== item && sibling.classList.contains('is-open')) {
            closeAllInside(sibling);
            setItem(sibling, false);
          }
        });
      }

      if (!willOpen) closeAllInside(item);
      setItem(item, willOpen);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-curtainproduct"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.hmReady) return;
    const dataEl = root.querySelector('[data-hm-data]');
    if (!dataEl) return;
    let D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.hmReady = '1';

    const q = (s, c = root) => c.querySelector(s);
    const qa = (s, c = root) => Array.from(c.querySelectorAll(s));
    const V = D.variants;

    /* ---------- money ---------- */
    const locale = D.currency === 'INR' ? 'en-IN' : (D.locale || undefined);
    const fmt = cents => {
      const whole = cents % 100 === 0;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: D.currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100);
      } catch (e) { return String(Math.round(cents / 100)); }
    };

    /* ---------- elements ---------- */
    const form = q('[data-form]');
    const vidInput = q('[data-variant-id]');
    const hiddenQty = q('[data-qty-hidden]');
    const qtyInput = q('[data-qty]');
    const atc = q('[data-atc]');
    const atcLabel = q('[data-atc-label]');
    const atcPrice = q('[data-atc-price]');
    const msg = q('[data-msg]');
    const priceEl = q('[data-price]');
    const compareEl = q('[data-compare]');
    const offEl = q('[data-off]');
    const mbar = q('[data-mbar]');
    const groups = qa('[data-option]');
    const packGi = groups.findIndex(g => g.dataset.role === 'pack');
    const sizeGi = groups.findIndex(g => g.hasAttribute('data-size'));
    const unitSelect = q('[data-unit-select]');

    /* ---------- state ---------- */
    let sel = groups.length
      ? groups.map(g => (q('input:checked', g) || q('input', g)).value)
      : V[0].options.slice();
    let qty = 1;
    let busy = false;
    const initialVariantId = vidInput ? Number(vidInput.value) : null;

    const variantFor = s => V.find(v => v.options.every((o, i) => o === s[i]));
    const currentVariant = () => variantFor(sel) || V[0];

    /* pick the closest existing variant when a chosen combination does not exist */
    function resolve(index, value) {
      const cands = V.filter(v => v.options[index] === value);
      if (!cands.length) return null;
      const score = v => v.options.reduce((n, o, i) => n + (i !== index && o === sel[i] ? 2 : 0), 0) + (v.available ? 1 : 0);
      return cands.reduce((best, v) => (score(v) > score(best) ? v : best));
    }

    const packCount = () => {
      if (packGi < 0) return 0;
      const i = q('input:checked', groups[packGi]);
      return i ? Number(i.dataset.count) || 0 : 0;
    };
    const plural = (n, w) => w + (n === 1 ? '' : 's');

    /* ---------- size units (CM / Inch / Feet) ---------- */
    const CM_PER_FT = 30.48;
    const UNIT_KEY = 'hm-size-unit';
    const VALID_UNITS = ['cm', 'inch', 'feet'];

    /* Metafield custom.size_dimensions is stored in FEET, e.g. "6", "5 x 7" or "6 ft x 4.5 ft". */
    function parseDims(str) {
      if (!str) return null;
      const nums = String(str).match(/\d+(?:\.\d+)?/g);
      if (!nums || !nums.length) return null;
      return nums.slice(0, 2).map(parseFloat);
    }

    /* Fallback when a variant has no metafield: read the variant name ("6 Ft", "72 inch", "180 cm") */
    function nameToFeet(text) {
      const m = String(text).match(/(\d+(?:\.\d+)?)/);
      if (!m) return null;
      const n = parseFloat(m[1]);
      const t = String(text).toLowerCase();
      if (/\bcm\b|centi/.test(t)) return n / CM_PER_FT;
      if (/inch|\bin\b|"/.test(t)) return n / 12;
      return n;
    }

    function sizeInfo(input) {
      const dims = parseDims(input.dataset.dims);
      if (dims) return { len: dims[0], wid: dims.length > 1 ? dims[1] : null };
      const ft = nameToFeet(input.value);
      return ft == null ? null : { len: ft, wid: null };
    }

    const trim1 = n => String(Math.round(n * 10) / 10);

    function fmtFeetInches(ft) {
      const totalIn = Math.round(ft * 12);
      const f = Math.floor(totalIn / 12);
      const i = totalIn % 12;
      if (!f) return i + ' in';
      return i ? f + ' ft ' + i + ' in' : f + ' ft';
    }

    function fmtLen(ft, unit) {
      if (unit === 'cm') return Math.round(ft * CM_PER_FT) + ' cm';
      if (unit === 'inch') return trim1(ft * 12) + '"';
      return fmtFeetInches(ft);
    }

    const currentUnit = () => (unitSelect ? unitSelect.value : 'feet');

    function sizeText(info, unit) {
      if (!info) return '';
      if (info.wid != null) return fmtLen(info.len, unit) + ' × ' + fmtLen(info.wid, unit);
      return fmtLen(info.len, unit);
    }

    function paintSizeUI() {
      if (sizeGi < 0) return;
      const unit = currentUnit();
      const inputs = qa('input', groups[sizeGi]);

      inputs.forEach(input => {
        const note = q('[data-size-note]', input.closest('.hm-opt'));
        const text = sizeText(sizeInfo(input), unit);
        if (note && text) note.textContent = text;
      });

      const lab = q('[data-selected]', groups[sizeGi]);
      const picked = inputs.find(i => i.value === sel[sizeGi]);
      const info = picked ? sizeInfo(picked) : null;
      if (lab) lab.textContent = '— ' + (info ? sizeText(info, unit) : sel[sizeGi]);
    }

    if (unitSelect) {
      try {
        const saved = localStorage.getItem(UNIT_KEY);
        if (saved && VALID_UNITS.includes(saved)) unitSelect.value = saved;
      } catch (e) {}

      unitSelect.addEventListener('change', () => {
        try { localStorage.setItem(UNIT_KEY, unitSelect.value); } catch (e) {}
        paintSizeUI();
      });
    }

    /* ---------- gallery ---------- */
    const thumbs = qa('[data-thumb]');
    const shot = q('[data-shot]');
    const caption = q('[data-caption]');
    let viewIndex = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));

    function srcsetFor(url, maxW) {
      const widths = [480, 720, 1000, 1400].filter(w => !maxW || w <= maxW);
      if (!widths.length) widths.push(480);
      try {
        return widths.map(w => { const u = new URL(url, location.href); u.searchParams.set('width', w); return u.href + ' ' + w + 'w'; }).join(', ');
      } catch (e) { return ''; }
    }

    function showThumb(i) {
      const t = thumbs[i];
      if (!t || !shot) return;
      viewIndex = i;
      thumbs.forEach(x => x.setAttribute('aria-pressed', x === t ? 'true' : 'false'));
      shot.hidden = false;
      shot.loading = 'eager';
      shot.src = t.dataset.src;
      shot.srcset = srcsetFor(t.dataset.src, Number(t.dataset.w));
      shot.alt = t.dataset.alt || D.title;
      if (caption) caption.textContent = t.dataset.label || '';
      if (window.matchMedia('(max-width:940px)').matches) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => showThumb(i)));
    q('[data-prev]')?.addEventListener('click', () => showThumb((viewIndex - 1 + thumbs.length) % thumbs.length));
    q('[data-next]')?.addEventListener('click', () => showThumb((viewIndex + 1) % thumbs.length));
    if (thumbs[viewIndex] && caption) caption.textContent = thumbs[viewIndex].dataset.label || '';

    /* ---------- painters ---------- */
    function paintAtc(v) {
      if (!atc) return;
      if (!busy) {
        atcLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
        atcPrice.hidden = !v.available;
        atcPrice.textContent = ' — ' + fmt(v.price * qty);
        atc.disabled = !v.available;
      }
      if (mbar) {
        q('[data-mbar-price]').textContent = fmt(v.price * qty);
        const n = (packCount() || 1) * qty;
        q('[data-mbar-unit]').textContent = packCount() ? n + ' ' + plural(n, D.noun) : '';
        const mb = q('[data-mbar-atc]');
        mb.textContent = v.available ? 'Add to bag' : 'Sold out';
        mb.disabled = !v.available || busy;
      }
    }

    let firstSync = true;
    function sync() {
      const v = currentVariant();
      vidInput.value = v.id;
      hiddenQty.value = qty;
      qtyInput.value = qty;

      /* option UI */
      groups.forEach((g, gi) => {
        qa('input', g).forEach(input => {
          input.checked = input.value === sel[gi];
          const ok = V.some(x => x.available && x.options.every((o, j) => (j === gi ? o === input.value : o === sel[j])));
          input.closest('.hm-opt').classList.toggle('is-soldout', !ok);
        });
        if (gi === sizeGi) return; /* size label is handled by paintSizeUI */
        const lab = q('[data-selected]', g);
        if (lab) lab.textContent = '— ' + sel[gi];
      });
      paintSizeUI();

      /* price and discount (already server-rendered on first paint) */
      if (!firstSync) {
        priceEl.textContent = fmt(v.price);
        const disc = v.compare > v.price;
        compareEl.hidden = offEl.hidden = !disc;
        if (disc) {
          compareEl.textContent = fmt(v.compare);
          offEl.textContent = Math.round((v.compare - v.price) / v.compare * 100) + '% off';
        }
      }

      /* switch to the variant's image */
      if (!firstSync && v.media) {
        const ti = thumbs.findIndex(t => t.dataset.mediaId == v.media);
        if (ti > -1) showThumb(ti);
      }

      /* keep the URL shareable */
      if (!firstSync && v.id !== initialVariantId) {
        try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      }

      paintAtc(v);
      firstSync = false;
    }

    /* ---------- options ---------- */
    root.addEventListener('change', e => {
      const input = e.target.closest('[data-option] input');
      if (!input) return;
      const gi = groups.indexOf(input.closest('[data-option]'));
      const v = resolve(gi, input.value);
      if (!v) return;
      sel = v.options.slice();
      sync();
    });

    /* ---------- RELATED PRODUCTS GROUP SLIDER ----------
       Arrows sirf tab dikhte hain jab 8 se zyada cards hon. */
    (function initGroupSlider() {
      const wrap = q('[data-grp-wrap]');
      if (!wrap) return;
      const list = q('[data-grp-list]', wrap);
      const prev = q('[data-grp-prev]', wrap);
      const next = q('[data-grp-next]', wrap);
      if (!list || !prev || !next) return;

      const cards = qa('.hm-grp-card', list);

      /* sold-out card par click block */
      list.addEventListener('click', e => {
        const c = e.target.closest('.hm-grp-card');
        if (c && c.classList.contains('is-sold-out')) e.preventDefault();
      });

      /* 8 ya kam items: arrows hide, no scroll */
      if (cards.length <= 8) {
        prev.classList.add('is-hidden');
        next.classList.add('is-hidden');
        list.style.overflowX = 'hidden';
        return;
      }

      list.style.overflowX = 'auto';

      const update = () => {
        const maxScroll = list.scrollWidth - list.clientWidth;
        const cur = list.scrollLeft;
        prev.classList.toggle('is-hidden', cur <= 5);
        next.classList.toggle('is-hidden', cur >= maxScroll - 5);
      };

      prev.addEventListener('click', () => list.scrollBy({ left: -(list.clientWidth * 0.8), behavior: 'smooth' }));
      next.addEventListener('click', () => list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' }));
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();

    /* ---------- quantity ---------- */
    const setQty = n => { qty = Math.min(99, Math.max(1, n || 1)); sync(); };
    q('[data-minus]').addEventListener('click', () => setQty(qty - 1));
    q('[data-plus]').addEventListener('click', () => setQty(qty + 1));
    qtyInput.addEventListener('change', () => setQty(parseInt(qtyInput.value, 10)));
    qtyInput.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); setQty(parseInt(qtyInput.value, 10)); } });

    /* ---------- add to cart (AJAX, stays on the page) ---------- */
    const setMsg = (text, ok) => { msg.textContent = text || ''; msg.classList.toggle('is-ok', !!ok); };
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const v = currentVariant();
      if (!v || !v.available || busy) return;
      busy = true;
      setMsg('');
      atcLabel.textContent = 'Adding…';
      atcPrice.hidden = true;
      atc.disabled = true;
      try {
        const res = await fetch(D.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body.description || body.message || 'Unable to add this item.');

        const cart = await fetch(D.cartJsUrl, { headers: { 'Accept': 'application/json' } }).then(r => r.json()).catch(() => null);

        const detail = cart || body;
        ['cart:refresh', 'cart:updated'].forEach(n => document.dispatchEvent(new CustomEvent(n, { detail })));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail }));

        if (D.redirect) { window.location.href = D.cartUrl; return; }
        setMsg('Added to bag.', true);
        busy = false;
        atcLabel.textContent = 'Added to bag ✓';
        setTimeout(() => { if (!busy) { paintAtc(currentVariant()); setMsg(''); } }, 1800);
      } catch (err) {
        busy = false;
        setMsg(err.message || 'Something went wrong. Please try again.');
        paintAtc(currentVariant());
      }
    });
    q('[data-mbar-atc]')?.addEventListener('click', () => atc.click());

    /* hide sticky bar while the main button is visible */
    const buyRow = q('[data-buy]');
    if (mbar && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => mbar.classList.toggle('is-hidden', en.isIntersecting), { threshold: 0.2 }).observe(buyRow);
    }

    /* ---------- pincode (serviceability only) ---------- */
    const pinInput = q('[data-pin-input]'), pinBtn = q('[data-pin-btn]'), pinOut = q('[data-pin-out]');
    if (pinInput && pinBtn) {
      const say = (text, err) => { pinOut.hidden = false; pinOut.textContent = text; pinOut.classList.toggle('is-error', !!err); };
      const check = async () => {
        const pin = pinInput.value.replace(/\D/g, '').slice(0, 6);
        pinInput.value = pin;
        if (!/^[1-9][0-9]{5}$/.test(pin)) { say('Enter a valid 6-digit pincode.', true); pinInput.focus(); return; }
        pinBtn.disabled = true;
        pinBtn.textContent = 'Checking…';
        say('Checking your pincode…');
        const ctl = new AbortController();
        const timer = setTimeout(() => ctl.abort(), 7000);
        try {
          const res = await fetch('https://api.postalpincode.in/pincode/' + pin, { signal: ctl.signal, headers: { 'Accept': 'application/json' } });
          const data = await res.json();
          const rec0 = data && data[0];
          if (!rec0 || rec0.Status !== 'Success' || !rec0.PostOffice || !rec0.PostOffice.length) throw new Error('not-found');
          const o = rec0.PostOffice[0];
          say(`Delivers to ${o.District}, ${o.State}.`);
        } catch (err) {
          say('We could not verify this pincode. Check the number and try again.', true);
        } finally {
          clearTimeout(timer);
          pinBtn.disabled = false;
          pinBtn.textContent = 'Check';
        }
      };
      pinBtn.addEventListener('click', check);
      pinInput.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    }

    /* ---------- Available offers: slider (mobile) + copy coupon ---------- */
    const ofrSlider = q('[data-ofr-slider]');
    if (ofrSlider) {
      const ofrCards = qa('.hm-ofr-card', ofrSlider);
      const ofrPrev = q('[data-ofr-prev]');
      const ofrNext = q('[data-ofr-next]');
      const ofrDots = q('[data-ofr-dots]');
      const mqOfr = window.matchMedia('(max-width:768px)');
      const dotBtns = [];

      const ofrStep = () => (ofrCards.length > 1 ? ofrCards[1].offsetLeft - ofrCards[0].offsetLeft : ofrSlider.clientWidth) || 1;
      const ofrIndex = () => Math.max(0, Math.min(ofrCards.length - 1, Math.round(ofrSlider.scrollLeft / ofrStep())));
      const ofrGo = i => {
        const card = ofrCards[Math.max(0, Math.min(ofrCards.length - 1, i))];
        if (card) ofrSlider.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      };

      if (ofrDots) {
        ofrCards.forEach((card, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Show offer ' + (i + 1));
          d.addEventListener('click', () => ofrGo(i));
          ofrDots.appendChild(d);
          dotBtns.push(d);
        });
      }

      const paintOfr = () => {
        const mobile = mqOfr.matches;
        const i = ofrIndex();
        if (ofrPrev) ofrPrev.disabled = !mobile || i === 0;
        if (ofrNext) ofrNext.disabled = !mobile || i >= ofrCards.length - 1;
        if (ofrDots) {
          ofrDots.hidden = !(mobile && ofrCards.length > 1);
          dotBtns.forEach((d, k) => {
            d.classList.toggle('is-active', k === i);
            d.setAttribute('aria-current', k === i ? 'true' : 'false');
          });
        }
      };

      ofrPrev?.addEventListener('click', () => { if (mqOfr.matches) ofrGo(ofrIndex() - 1); });
      ofrNext?.addEventListener('click', () => { if (mqOfr.matches) ofrGo(ofrIndex() + 1); });
      ofrSlider.addEventListener('scroll', paintOfr, { passive: true });
      window.addEventListener('resize', paintOfr);
      if ('ResizeObserver' in window) new ResizeObserver(paintOfr).observe(ofrSlider);
      paintOfr();
    }

    const fallbackCopy = (code, done) => {
      const t = document.createElement('textarea');
      t.value = code;
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { if (document.execCommand('copy')) done(); } catch (e) {}
      t.remove();
    };

    qa('[data-copy]').forEach(el => {
      const run = () => {
        const code = el.dataset.code;
        const label = q('.hm-ofr-code', el);
        if (!code || !label) return;
        const done = () => {
          const original = label.textContent;
          label.textContent = 'COPIED!';
          setTimeout(() => { label.textContent = original; }, 2000);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done).catch(() => fallbackCopy(code, done));
        } else {
          fallbackCopy(code, done);
        }
      };
      el.addEventListener('click', run);
      el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); run(); } });
    });

    /* ---------- Feature badges: slider dots (mobile, 2 per page) ---------- */
    const badgeBox = q('.hm-badges');
    const badgeDots = q('[data-badge-dots]');
    if (badgeBox && badgeDots) {
      const items = qa('.hm-badge', badgeBox);
      const pages = Math.ceil(items.length / 2);
      const mqBadge = window.matchMedia('(max-width:640px)');
      const bDots = [];

      for (let i = 0; i < pages; i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Show features ' + (i + 1));
        d.addEventListener('click', () => {
          const target = items[i * 2];
          if (target) badgeBox.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
        badgeDots.appendChild(d);
        bDots.push(d);
      }

      const bStep = () => (items[2] ? items[2].offsetLeft - items[0].offsetLeft : badgeBox.clientWidth) || 1;
      const paintBadges = () => {
        const show = mqBadge.matches && pages > 1;
        badgeDots.hidden = !show;
        const i = Math.max(0, Math.min(pages - 1, Math.round(badgeBox.scrollLeft / bStep())));
        bDots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      };

      badgeBox.addEventListener('scroll', paintBadges, { passive: true });
      window.addEventListener('resize', paintBadges);
      paintBadges();
    }

    sync();

    /* Judge.me can populate its badge after the section loads */
    if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') window.jdgm.renderWidgets();
  }

  const initAll = scope => (scope || document).querySelectorAll('[data-hm-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
